export interface ProspectTotalJson {
  my_companies_to_create: number;
}

export class ProspectTotal {
  constructor(public myCompaniesToCreate?: number) {}

  static fromJson(json: Partial<ProspectTotalJson>): ProspectTotal {
    return new ProspectTotal(json.my_companies_to_create);
  }
}
